import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { faCrosshairs, faXmark } from '@fortawesome/pro-solid-svg-icons';
import { ButtonComponent, IconComponent } from '@pure/hive';

/**
 * The only client-side triage surface: a compact indicator above the composer saying the
 * conversation is in triage mode, with a control to cancel out of it.
 *
 * Deliberately does NOT show the question. The assistant's question renders as an ordinary
 * message in the stream, so repeating it here would ask the same thing twice.
 *
 * Cancelling matters more than it looks: the backend never offers an exit as a reply
 * option, so this control is the only way out of a paused run.
 */
@Component({
    selector: 'copilot-triage-status',
    templateUrl: './triage-status.component.html',
    styleUrls: ['./triage-status.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    preserveWhitespaces: false,
    imports: [ButtonComponent, IconComponent],
})
export class TriageStatusComponent {
    readonly exitTriage = output<void>();

    protected readonly faCrosshairs = faCrosshairs;
    protected readonly faXmark = faXmark;
}
